/**
 * <s-mobile-accordion> — Wraps <details> items that should act as an accordion on
 * small screens but stay fully open on wider screens. On md+ every item is opened
 * and summary clicks are ignored; below md items start closed.
 */
class SMobileAccordion extends HTMLElement {
  #mq = window.matchMedia('(min-width: 48rem)');
  #onChange = () => this.#sync();
  #onClick = (event) => {
    if (this.#mq.matches && event.target.closest('summary')) event.preventDefault();
  };

  connectedCallback() {
    this.#mq.addEventListener('change', this.#onChange);
    this.addEventListener('click', this.#onClick);
    this.#sync();
  }

  disconnectedCallback() {
    this.#mq.removeEventListener('change', this.#onChange);
    this.removeEventListener('click', this.#onClick);
  }

  #sync() {
    const desktop = this.#mq.matches;
    for (const details of this.querySelectorAll(':scope details')) details.open = desktop;
  }
}

if (!customElements.get('s-mobile-accordion')) customElements.define('s-mobile-accordion', SMobileAccordion);
